/* tslint:disable */
/* eslint-disable */
/**
 * MachineGo P1 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ResetPasswordViewModel
 */
export interface ResetPasswordViewModel {
    /**
     * 
     * @type {string}
     * @memberof ResetPasswordViewModel
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof ResetPasswordViewModel
     */
    otpCode: string;
    /**
     * 
     * @type {string}
     * @memberof ResetPasswordViewModel
     */
    password: string;
}

export function ResetPasswordViewModelFromJSON(json: any): ResetPasswordViewModel {
    return ResetPasswordViewModelFromJSONTyped(json, false);
}

export function ResetPasswordViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResetPasswordViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'email': json['email'],
        'otpCode': json['otpCode'],
        'password': json['password'],
    };
}

export function ResetPasswordViewModelToJSON(value?: ResetPasswordViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'email': value.email,
        'otpCode': value.otpCode,
        'password': value.password,
    };
}

